import { disableMessage } from '@/utils/firebase/initialize';
import { useMediaQuery } from 'usehooks-ts';
import { minBreakpoints } from '@/utils/mediaQuery';
import React, { useEffect } from 'react';
import { rnPermissionDeny } from '@/utils/function';
import PageHead from '@/components/@IntranetLibrary/PageHead';
import Login from '@/components/Login';
import { useRouter } from 'next/router';
import { StyledError } from '@/components/Login/styles';

const Page = () => {
  const isDeskTop = useMediaQuery(`${minBreakpoints.md}`);
  isDeskTop && disableMessage();
  const router = useRouter();
  const errorType = router.query.errorType as string | undefined;

  const errorComponent =
    errorType === 'MS' ? (
      <StyledError>
        MS 로그인 연결이 원활하지 않아요.
        <br />
        도움이 필요하면 &#39;
        <a
          style={{ textDecoration: 'underline' }}
          href={
            'https://teams.microsoft.com/l/channel/19%3A1531f697e56c49f196e999deccfe33fb%40thread.skype/01.%20Office365%20QnA%20for%20Korea?groupId=4bd8810b-c9ca-4221-a9f4-c95fc4086bb8&tenantId=c0f5d9c6-f2df-4b78-85aa-5d4d82ce0cb5'
          }
          target={'_blank'}
          rel={'noopener noreferrer'}
        >
          Office365 QnA 채널
        </a>
        &#39;에 문의해 주세요.
      </StyledError>
    ) : errorType === 'portal' ? (
      <StyledError>
        포탈 시스템 연결이 원활하지 않아요.
        <br />
        도움이 필요하면 &#39;
        <a
          style={{ textDecoration: 'underline' }}
          href={
            'https://fnf.atlassian.net/servicedesk/customer/portal/50/group/154/create/813'
          }
          target={'_blank'}
          rel={'noopener noreferrer'}
        >
          IT Service 오류보고
        </a>
        &#39;에 문의해 주세요.
      </StyledError>
    ) : null;

  useEffect(() => {
    //RN에서는 이 화면이 오면 세션만료시킨다.
    rnPermissionDeny(4);
  }, []);

  return (
    <>
      <PageHead headTitle={'Login - F&F Portal'} />
      <Login error={errorComponent} />
    </>
  );
};

export default Page;
